import { Container, Paper, Typography } from '@mui/material';
import { useTranslations } from 'next-intl';
interface NoResultBlockProps {
  keyword: string | null;
}

export const QuickSearchNoResultBlock: React.FC<NoResultBlockProps> = ({
  keyword,
}: NoResultBlockProps) => {
  const t = useTranslations('Search');
  return (
    <Paper elevation={4}>
      <Container sx={{ paddingLeft: 2, paddingRight: 2, paddingTop: 2, paddingBottom: 2 }}>
        <Typography>{t('zero-results', { keyword })}</Typography>
      </Container>
    </Paper>
  );
};
